import React from "react";
import { Divider, styled, Theme, useMediaQuery } from "@mui/material";
import { Box } from "@mui/material";
import { PoweredBy } from "./PoweredBy";
import TLSLogo from "./tls-logo.svg?react";
import BaFinLogo from "./bafin-logo.svg?react";
import IsoLogo from "./iso-logo.svg?react";

const FooterContainer = styled("div")`
  max-width: 716px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(5)};
  justify-content: center;
  padding-top: ${({ theme }) => theme.spacing(7)};
  border-top: 1px solid ${({ theme }) => theme.palette.border.secondary};
  margin: ${({ theme }) => theme.spacing(0, 4)};

  ${({ theme }) => theme.breakpoints.down(720)} {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(3.5)};
    padding-top: ${({ theme }) => theme.spacing(5)};
  }
`;

const Footer = styled("div")`
  width: 100%;
  display: flex;
  gap: ${({ theme }) => theme.spacing(5)};
  align-items: center;
  justify-content: space-between;

  ${({ theme }) => theme.breakpoints.down(720)} {
    max-width: 400px;
  }
  ${({ theme }) => theme.breakpoints.down(400)} {
    max-width: 320px;
    gap: ${({ theme }) => theme.spacing(3)};
  }
`;

const IsoLogoContainer = styled("div")`
  display: flex;
  border: 1px solid ${({ theme }) => theme.palette.border.secondary};
  border-radius: 7px;
  overflow: hidden;
`;

const sslSMSizes = {
  lg: {
    height: 40,
    width: 149,
  },
  md: {
    height: 32,
    width: 121,
  },
  sm: {
    height: 23,
    width: 93,
  },
};

const bafinSizes = {
  lg: {
    height: 38,
    width: 131,
  },
  md: {
    height: 32,
    width: 110,
  },
  sm: {
    height: 26,
    width: 89,
  },
};

const isoSizes = {
  lg: {
    height: 60,
    width: 86,
  },
  md: {
    height: 51,
    width: 75,
  },
  sm: {
    height: 42,
    width: 63,
  },
};

export const TrustFooter = () => {
  const isLess720 = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down(720)
  );
  const isDown400 = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down(400)
  );
  const isDownMD = useMediaQuery((theme: Theme) => theme.breakpoints.down(800));

  const sizeKey = isDown400 ? "sm" : isDownMD ? "md" : "lg";

  return (
    <FooterContainer>
      <PoweredBy />

      <Divider
        orientation={isLess720 ? "horizontal" : "vertical"}
        sx={{
          width: isLess720 ? "350px" : "auto",
        }}
      />

      <Footer>
        <Box sx={{ color: (theme) => theme.palette.wizardHeader.logoBafin }}>
          <BaFinLogo aria-label="BaFin Logo" {...bafinSizes[sizeKey]} />
        </Box>
        <IsoLogoContainer>
          <IsoLogo aria-label="ISO Logo" {...isoSizes[sizeKey]} />
        </IsoLogoContainer>
        <Box sx={{ color: (theme) => theme.palette.wizardHeader.logoSsl }}>
          <TLSLogo aria-label="TSL Logo" {...sslSMSizes[sizeKey]} />
        </Box>
      </Footer>
    </FooterContainer>
  );
};
